module.exports = __webpack_public_path__ + "static/richard-pitt-oil-painting-fa14f6a8efb9362484b5b7df07a29f20.jpg";